import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import '../student/Newstudent.css';
import AllNotes from '../notes/AllNotes.js';
import StudentToetsResults from '../toetsen/StudentToetsResults.js';

function ViewStudent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { userInfo } = useAuth();
  const userRole = userInfo?.role;

  const [isLoading, setIsLoading] = useState(true);
  const [values, setValues] = useState({
    student_id: '',
    firstname: '',
    lastname: '',
    birthdate: '',
    datein: '',
    dateout: '',
    street: '',
    housenr: '',
    postalcode: '',
    city: '',
    school: '',
    allergy: '',
    iban: '',
    accountowner: '',
    monthlyamount: '',
    comments: '',
    mailing: '',
    toestemmingfoto: '',
    customer_student_number: '',
  });

  const [parents, setParents] = useState([]);
  const [isLoadingParents, setIsLoadingParents] = useState(true);

  const fetchStudent = useCallback(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/students/getstudent/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setValues(response.data.Data || {});
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching student:', err);
        setIsLoading(false);
      });
  }, [id, token]);

  const fetchParents = useCallback(() => {
    setIsLoadingParents(true);

    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/student-parents/student/${id}/parents`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        setParents(res.data.data || []);
        setIsLoadingParents(false);
      })
      .catch((err) => {
        console.error('Error fetching parents for student:', err);
        setIsLoadingParents(false);
      });
  }, [id, token]);

  useEffect(() => {
    fetchStudent();
    fetchParents();
  }, [fetchStudent, fetchParents]);

  const handleCancel = () => navigate('/allstudents');

  if (isLoading) return <p>Loading studentgegevens…</p>;

  return (
    <div className="bg-white p-4">
      <h2 className="text-center">Gegevens Leerling</h2>
      <hr className="seperator" />
      {["super_admin", "locatie_admin", "docent"].includes(userRole) && (
        <div className="mb-3">
          <Link className="btn btn-outline-primary" to={`/toetsen?student_id=${id}&student_name=${encodeURIComponent(`${values.firstname || ''} ${values.lastname || ''}`.trim())}`}>
            Toetsresultaten bekijken
          </Link>
        </div>
      )}


      <p>
        <strong>Studentnummer:</strong> {values.customer_student_number || ''}
      </p>
      <hr className="seperator" />

      {userRole === 'docent' ? (
        <div>
          <p>
            <strong>Id:</strong> {values.student_id || ''}
          </p>
          <p>
            <strong>Voornaam:</strong> {values.firstname || ''}
          </p>
          <p>
            <strong>Achternaam:</strong> {values.lastname || ''}
          </p>
          <hr className="seperator" />

          <h5>Ouders</h5>
          {isLoadingParents ? (
            <p>Loading ouders…</p>
          ) : parents.length ? (
            parents.map((p) => (
              <div key={p.parent_id} className="mb-2">
                <p>
                  <strong>Naam:</strong> {p.firstname} {p.lastname}
                </p>
                <p>
                  <strong>Email:</strong> {p.email}
                </p>
                <p>
                  <strong>Mobiel:</strong> {p.mobile}
                </p>
                <p>
                  <strong>Relatie:</strong> {p.relationship}
                </p>
                <hr />
              </div>
            ))
          ) : (
            <p>Geen ouders gekoppeld.</p>
          )}

          <StudentToetsResults key={id} studentId={id} studentName={`${values.firstname || ''} ${values.lastname || ''}`.trim()} />
          <div className="row">
            <AllNotes studentId={id} collapsible />
          </div>
        </div>
      ) : (
        <form className="form-student">
          <div className="row">
            <div className="mb-3 col">
              <label>Voornaam</label>
              <input className="form-control" value={values.firstname || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Achternaam</label>
              <input className="form-control" value={values.lastname || ''} readOnly />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label>Geboortedatum</label>
              <input className="form-control" value={values.birthdate || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Datum Inschrijving</label>
              <input className="form-control" value={values.datein || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Datum Uitschrijving</label>
              <input className="form-control" value={values.dateout || ''} readOnly />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label>Postcode</label>
              <input className="form-control" value={values.postalcode || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Huisnummer</label>
              <input className="form-control" value={values.housenr || ''} readOnly />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label>Straat</label>
              <input className="form-control" value={values.street || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Plaats</label>
              <input className="form-control" value={values.city || ''} readOnly />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col">
              <label>School</label>
              <input className="form-control" value={values.school || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Allergie</label>
              <input className="form-control" value={values.allergy || ''} readOnly />
            </div>
          </div>

          <div className="mb-3">
            <label>Opmerkingen</label>
            <textarea className="form-control" rows="5" value={values.comments || ''} readOnly />
          </div>

          <hr className="seperator" />

          <div className="row">
            <div className="mb-3 col">
              <label>IBAN</label>
              <input className="form-control" value={values.iban || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Rekeninghouder</label>
              <input className="form-control" value={values.accountowner || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Maandbedrag</label>
              <input className="form-control" value={values.monthlyamount || ''} readOnly />
            </div>
          </div>

          <hr className="seperator" />

          <h5>Ouders</h5>
          {isLoadingParents ? (
            <p>Loading ouders…</p>
          ) : parents.length ? (
            parents.map((p) => (
              <div key={p.parent_id} className="mb-2">
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label>Voornaam</label>
                    <input className="form-control" value={p.firstname || ''} readOnly />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label>Achternaam</label>
                    <input className="form-control" value={p.lastname || ''} readOnly />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label>Email</label>
                    <input className="form-control" value={p.email || ''} readOnly />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label>Mobiel</label>
                    <input className="form-control" value={p.mobile || ''} readOnly />
                  </div>
                </div>
                <div className="mb-3">
                  <label>Relatie</label>
                  <input className="form-control" value={p.relationship || ''} readOnly />
                </div>
                <hr className="seperator" />
              </div>
            ))
          ) : (
            <p>Geen ouders gekoppeld.</p>
          )}

          <hr className="seperator" />

          <p className="text-center font-italic">AVG</p>
          <div className="row">
            <div className="mb-3 col">
              <label>Mailing</label>
              <input className="form-control" value={values.mailing || ''} readOnly />
            </div>
            <div className="mb-3 col">
              <label>Toestemming Foto</label>
              <input className="form-control" value={values.toestemmingfoto || ''} readOnly />
            </div>
          </div>

          <hr className="seperator" />
          <StudentToetsResults key={id} studentId={id} studentName={`${values.firstname || ''} ${values.lastname || ''}`.trim()} />
          <div className="row">
            <AllNotes studentId={id} collapsible />
          </div>

          <div className="row">
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-secondary w-100 rounded-0"
                onClick={handleCancel}
              >
                Terug
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default ViewStudent;